import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ManageStockService {

  constructor(private _http: HttpClient, private _toastrService: ToastrService) { }

  getData(start, length): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}get-stock`, { start, length })
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  add(user_id:any,product_id:any,type:any,qty:any,remark:any, id: any): Observable<any> {
    if (id == 0) {
      return this._http
        .post(`${environment.apiUrl}save-stock`, { user_id, product_id,type, qty, remark})
        .pipe(
          map(data => {
            return data;
          })
        );
    }
  }
}
